import { axios } from '@ben/api/axios';
import type { IFile } from '@ben/orion/file-upload-lists';

const getEnrolmentFieldFilesPath = (enrolmentId: number, fieldId: number) =>
  `ecc/v1.0/benefits/enrolments/${enrolmentId}/fields/${fieldId}/files`;

export const uploadEnrolmentDocument = async (
  files: File[],
  enrolmentId: number,
  fieldId: number
) => {
  const responses: IFile[] = [];
  for (const file of files) {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(
      `${getEnrolmentFieldFilesPath(enrolmentId, fieldId)}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    responses.push(response.data);
  }

  return responses;
};

export const deleteEnrolmentDocument = async (
  uuid: string,
  enrolmentId: number,
  fieldId: number
) => {
  const response = await axios.delete(
    `${getEnrolmentFieldFilesPath(enrolmentId, fieldId)}/${uuid}/`
  );
  return response.data;
};
